export default __webpack_public_path__ + "static/media/summit_shaper.5694fc09.png";